<div class="feedback-container w-100 h-100 background-image" >
    <div class="spacer h-100 float-start"></div>
    <div class="logo-container">
        <img src="assets/images/icons/monex_login_icon.svg" alt="monex-icon"><br>
    </div>
    <div class="line-container">
        <hr class="vr-line">
    </div>
    <div class="feedback-content">
        <div class="fb-content">
            <span class="fb-1">{{"Nos encantaria saber cual fue tu experiencia." | translate}}</span><br><br>
            <span class="fb-2">{{"Da" | translate}} </span>
            <span class="fb-3" (click)="showFormFeedback()">{{"clic aqui" | translate}}</span>
            <span class="fb-2"> {{"y cuéntanos como te fue." | translate}}</span><br><br><br>

            <div class="fb-btn">
                <button type="button" class="btn btn-banca-digital" (click)="showBancaDigital()">
                    <span>{{"Regresar a la Banca Digital" | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
